import { UserRole } from '~/constants';

/**
 * Resolve a user-supplied redirect target against the current origin and only
 * return it when it stays same-origin. Rejects cross-origin URLs, other schemes
 * (e.g. javascript:), and protocol-relative (//evil.com) values, which would
 * otherwise be an open redirect. Returns a relative path on success, null
 * otherwise.
 */
function toSameOriginPath(redirectUri: string): string | null {
  try {
    const url = new URL(redirectUri, window.location.origin);
    if (url.origin !== window.location.origin) {
      return null;
    }
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
}

/**
 * Send the user to their landing page after a fully-authenticated login.
 * Honours a ?redirect_uri= query param when present.
 */
export default function redirectAfterLogin(user: any) {
  const urlParams = new URLSearchParams(window.location.search);
  const redirectUri = urlParams.get('redirect_uri');
  const safePath = redirectUri ? toSameOriginPath(redirectUri) : null;
  if (safePath) {
    window.location.href = safePath;
  } else if (user?.role?.code === UserRole.EXTERNAL) {
    window.location.href = '/my-deals';
  } else if (user?.role?.code === 'ADMIN') {
    window.location.href = '/dashboard';
  } else {
    window.location.href = '/';
  }
}
